import { Menu } from 'antd';
import propTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { sidebarItems } from '../utils/constants';

function MenuItems() {
  const { path } = useRouteMatch();
  const role = useSelector((state) => state.authUser.role);
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname; // Obtiene la ruta actual

  let selectedKey = '';
  let openKey = '';

  for (const item of sidebarItems) {
    if (item.path && currentPath.includes(item.path)) {
      selectedKey = item.key;
      break;
    }
  
    if (item.items) {
      const match = item.items.find((subitem) => currentPath.includes(subitem.path));
      if (match) {
        selectedKey = match.key;
        openKey = item.key; // abrimos también el submenu padre
        break;
      }
    }
  }
  //Menú a estructura `items`
  const menuItems = sidebarItems
    .filter((menu) => menu.roles.includes(role))
    .map((menu) => {
      if (menu.items) {
        // Si hay submenús
        return {
          key: menu.key,
          icon: <img src={menu.image} alt={menu.title} style={{ width: 16, height: 16 }} />,
          label: menu.title,
          children: menu.items.map((child) => ({
            key: child.key,
            label: child.label,
            onClick: () => child.path && history.push(`${path}${child.path}`),
          })),
        };
      }
      // Si es un solo elemento
      return {
        key: menu.key,
        icon: <img src={menu.image} alt={menu.title} style={{ width: 16, height: 16 }} />,
        label: menu.title,
        onClick: () => history.push(`${path}${menu.path}`),
      };
    });

  return (
    <Menu
      mode="inline"
      className="ant-menu-sidebar"
      selectedKeys={[selectedKey]}
      defaultOpenKeys={[openKey]} // 👈 importante para mostrar submenu abierto


      items={menuItems}
    />
  );
}

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
